// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".per-page-selector[data-v-1b5737ce]{width:90px}[dir] .icon-activity[data-v-1b5737ce]{cursor:pointer}[dir=ltr] .icon-activity[data-v-1b5737ce]{margin-left:.5rem}[dir=rtl] .icon-activity[data-v-1b5737ce]{margin-right:.5rem}.icon-activity[data-v-1b5737ce]:hover{color:var(--white)!important}[dir] .icon-activity[data-v-1b5737ce]:hover{background-color:var(--primary)!important}", ""]);
// Exports
module.exports = exports;
